import React from 'react';
import '../assets/css/spinner.css';

const Spinner = () => (
  <div className="loader" />
);

export default Spinner;
